import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BreakpointConstant } from '../../components/constants/breakpoint.constant';

/**
 * Offers common breakpoints to reuse within the application.
 * Alls breakpoints are constructed with "max-width". That means,
 * they say if a screen is smaller than that.
 *
 * Examples
 * `mobile` means, that the screen is of mobile size or smaller
 * `tablet` means, that the screen is of tablet size or smaller
 */
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  public readonly mobile: Observable<boolean>;
  public readonly tablet: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.mobile = this.breakpointObserver.observe([`(max-width: ${BreakpointConstant.MOBILE_LARGE}px)`]).pipe(
      untilDestroyed(this),
      map((result: BreakpointState) => result.matches),
    );

    this.tablet = this.breakpointObserver.observe([`(max-width: ${BreakpointConstant.TABLET}px)`]).pipe(
      untilDestroyed(this),
      map((result: BreakpointState) => result.matches),
    );
  }
}
